import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-update-payment-info',
  templateUrl: './update-payment-info.component.html',
  styleUrls: ['./update-payment-info.component.scss']
})
export class UpdatePaymentInfoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
